export default __webpack_public_path__ + "static/media/INFP.b561c631.svg";